export const passwordRegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;

export const validateField = schema => val => {
  try {
    schema.validateSync(val);
  } catch (error) {
    return error.message;
  }
};
